import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const staffGuard: CanActivateFn = async () => {
  // inject() only works before the first await.
  const auth = inject(AuthService);
  const router = inject(Router);

  // A refresh on the staff panel must wait for the saved session to be restored.
  await auth.ready;
  return auth.isLoggedIn() || router.createUrlTree(['/staff/login']);
};
